import React from 'react';

export default function ShikshaLogo({ size = 32, showText = true, textColor, onClick }) {
  return (
    <div className="flex items-center gap-3" data-testid="shiksha-logo"
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default', userSelect: 'none' }}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => { if (e.key === 'Enter') onClick(); } : undefined}>
      <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"
        style={{ flexShrink: 0, filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.12))' }}>
        <circle cx="32" cy="32" r="30" fill="#006A4E"/>
        <circle cx="32" cy="28" r="10" fill="#F42A41"/>
        <path d="M22 26 L32 23 L42 26 L42 44 L32 41 L22 44 Z" fill="white" opacity="0.95"/>
        <line x1="32" y1="23" x2="32" y2="41" stroke="#006A4E" strokeWidth="1"/>
        <path d="M32 19 L24 23 L32 27 L40 23 Z" fill="white"/>
      </svg>
      {showText && (
        <div style={{ lineHeight: 1.15 }}>
          <div style={{ fontSize: size * 0.55, fontWeight: 700, letterSpacing: '-0.02em', color: textColor || 'var(--color-label-primary)' }}>
            Shiksha <span style={{ color: '#F42A41' }}>BD</span>
          </div>
          <div style={{ fontSize: size * 0.24, color: 'var(--color-label-tertiary)', letterSpacing: '0.02em' }}>
            শিক্ষা বিডি
          </div>
        </div>
      )}
    </div>
  );
}
